import { useSingleQueryParam } from '@app/hooks/useSingleQueryParam';

export default function useSkipWelcomeFromLocation(): boolean {
  const [skipWelcome] = useSingleQueryParam('skipWelcome', /.*/);

  return skipWelcome?.toLowerCase() === 'true';
}
